import React from "react";
import { Controller, useFormContext } from "react-hook-form";
import styled from "styled-components";
import { CurrencyInput, Label, Select } from "@components";
import { Category, RootProductId } from "@models";
import { ConfigModuleSetting } from "./types";
import { escapeCategoryId, isYearlyBudget } from "../util";
import { Currency } from "@util";

type Props = {
	productId: RootProductId;
	category: Category;
};

export default function BudgetCategoryAmounts(props: Props) {
	const { productId, category } = props;
	const { control } = useFormContext<ConfigModuleSetting>();
	const namePrefix = `amounts.${escapeCategoryId(category.id)}`;

	const enabledCouponAmounts = [15_00, 25_00, 30_00, 50_00] as const;

	return (
		<div data-testid={`budgetCategory-${category.id}`}>
			<FlexCol>
				<FlexRow>
					<Label>
						{isYearlyBudget(category.id)
							? "Max. Betrag/Jahr"
							: productId === "sachbezug"
							? "Betrag/Monat"
							: "Max. Betrag/Monat"}

						{productId === "sachbezug" ? (
							<Controller
								name={`${namePrefix}.maxAmountMonth` as any}
								control={control}
								render={({ field }) => (
									<Select
										id={`${productId}-category-select`}
										{...field}
										onChange={(event: React.ChangeEvent<HTMLSelectElement>) => {
											field.onChange(Number(event.target.value));
										}}
									>
										{enabledCouponAmounts.map((amount) => (
											<option key={amount} value={amount}>
												{Currency.format(amount)}
											</option>
										))}
									</Select>
								)}
							/>
						) : (
							<Controller
								name={`${namePrefix}.maxAmountMonth` as any}
								control={control}
								render={({ field }) => <CurrencyInput {...field} />}
							/>
						)}
					</Label>
					{!category.id.startsWith("sachbezug") && (
						<Label>
							Max. Betrag/Tag
							<Controller
								name={`${namePrefix}.maxAmountDay` as any}
								defaultValue={null}
								control={control}
								render={({ field }) => (
									<CurrencyInput
										placeholder="unbeschränkt"
										{...field}
										allowNull
									/>
								)}
							/>
						</Label>
					)}
				</FlexRow>
			</FlexCol>
		</div>
	);
}

const FlexCol = styled.div`
	display: flex;
	flex-direction: column;
`;

const FlexRow = styled.div`
	display: flex;
	flex-direction: row;
	gap: 0.5rem;
`;
